import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("mel_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
